module.exports = __webpack_public_path__ + "static/img/bi.a2668b0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/layer1/bi.png
// module id = RfOy
// module chunks = 1